import { render, staticRenderFns } from "./ReleasesPage.vue?vue&type=template&id=7f6ec560&scoped=true&"
import script from "./ReleasesPage.vue?vue&type=script&lang=js&"
export * from "./ReleasesPage.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesPage.vue?vue&type=style&index=0&id=7f6ec560&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ec560",
  null
  
)

component.options.__file = "ReleasesPage.vue"
export default component.exports